<template>
  <ControlField label="Person">
    <div class="columns m-0" v-if="innerValue.id">
      <router-link :to="{name: 'contact', params: { id: innerValue.id } } ">{{ innerValue.firstname }} {{ innerValue.lastname }}</router-link>
      <button class="button is-small is-align-self-flex-end" @click="unlink">Unlink</button>
    </div>
    <div class="columns m-0" v-else>
      <ValidatedInput :value="innerValue.firstname" @input="onInput('firstname', $event)" rules="" label="Firstname" :horizontal="false" />
      <ValidatedInput :value="innerValue.lastname" @input="onInput('lastname', $event)" rules="" label="Lastname" :horizontal="false" />
      <button v-if="innerValue.firstname && innerValue.lastname" class="button is-small is-align-self-flex-end" @click="link">Link</button>
    </div>
  </ControlField>
</template>
<script>
import ValidatedInput from '@/components/form/ValidatedInput.vue';
import expressions from 'angular-expressions';
import ContactService from '@/services/ContactService';
import ContactLinkDialog from './ContactLinkDialog.vue';
export default {
  components: { ValidatedInput },
  props: {
    vpath: {
      type: String
    },
    path: {
      type: String
    },
    value: {
      type: Object
    }
  },
  data: () => ({
    innerValue: ({})
  }),
  watch: {
    value: {
      deep: true,
      handler() {
        const evaluate = expressions.compile(this.path);
        this.innerValue = evaluate(this.value) || {};
      }
    }
  },

  created() {
    if (this.value) {
      const evaluate = expressions.compile(this.path);
      this.innerValue = evaluate(this.value) || {};
    }
  },

  methods: {
    onInput(name, value) {
      this.innerValue[name] = value;
      this.$emit('update-with-path', {
        path: this.path,
        value: this.innerValue
      });
    },
    unlink() {
      this.onInput('id', undefined);
    },
    async link(item) {
      const response = await ContactService.link(Object.assign({}, this.innerValue, { type: 'PERSON' }, item));

      if (response.data?.name) {
        this.onInput('name', response.data?.name);
      }
      if (response.data?.vat_number) {
        this.onInput('vat_number', response.data?.vat_number);
      }

      if (response.data?.id) {
        this.onInput('id', response.data?.id);
        return;
      }

      if (response.data?.existing) {
        this.$oruga.modal.open({
          parent: this,
          component: ContactLinkDialog,
          hasModalCard: true,
          props: {
            existing: response.data?.existing
          },
          events: {
            create: async () => {
              await this.link(Object.assign({}, this.innerValue, { type: 'PERSON', force: true }));
            },
            link: async (row) => {
              await this.link(row);
            }
          }
        });
      }
    }
  }

};
</script>
